import React, { useEffect, useRef } from "react"
import { useFrame, useLoader } from "@react-three/fiber"
import { useGLTF } from '@react-three/drei'
import { RGBMLoader } from "three-stdlib"
import * as THREE from 'three'

function ticktock(tickRef, tockRef, clockRef, interval, delta) {
  if(!tickRef.current || !tockRef.current ) {
    return false
  }

  clockRef.current = delta + clockRef.current
  if(clockRef.current > interval) {
    clockRef.current = 0
    if(tickRef.current.visible) {
      tickRef.current.visible = false
      tockRef.current.visible = true
    } else {
      tickRef.current.visible = true
      tockRef.current.visible = false
    }
  }
}

useLoader.preload(RGBMLoader, ['BigCube_denoised_encoded.png',
'BoxForTree_denoised_encoded.png',
'ClockOnBoxForTree_denoised_encoded.png',
'ClockOnLowLongBox_denoised_encoded.png',
'ClockOnTree_denoised_encoded.png',
'LowCube_denoised_encoded.png',
'LowLongCube_denoised_encoded.png',
'Room_denoised_encoded.png',
'SmallCube_denoised_encoded.png',
'Tree_denoised_encoded.png'])
useGLTF.preload('room.glb')


export default function Room(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('room.glb', './')
  

  

  const [BigCube, BoxForTree, ClockOnBoxForTree, ClockOnLowLongBox, ClockOnTree, LowCube, LowLongCube, Room, SmallCube, Tree] = useLoader(RGBMLoader, ['BigCube_denoised_encoded.png',
  'BoxForTree_denoised_encoded.png',
  'ClockOnBoxForTree_denoised_encoded.png',
  'ClockOnLowLongBox_denoised_encoded.png',
  'ClockOnTree_denoised_encoded.png',
  'LowCube_denoised_encoded.png',
  'LowLongCube_denoised_encoded.png',
  'Room_denoised_encoded.png',
  'SmallCube_denoised_encoded.png',
  'Tree_denoised_encoded.png'])
  
  BigCube.encoding = THREE.RGBM7Encoding;
  BigCube.flipY = false;
  const BigCubeMat = new THREE.MeshBasicMaterial({ map: BigCube })

  BoxForTree.encoding = THREE.RGBM7Encoding;
  BoxForTree.flipY = false;
  const BoxForTreeMat = new THREE.MeshBasicMaterial({ map: BoxForTree })

  ClockOnBoxForTree.encoding = THREE.RGBM7Encoding;
  ClockOnBoxForTree.flipY = false;
  const ClockOnBoxForTreeMat = new THREE.MeshBasicMaterial({ map: ClockOnBoxForTree })

  ClockOnLowLongBox.encoding = THREE.RGBM7Encoding;
  ClockOnLowLongBox.flipY = false;
  const ClockOnLowLongBoxMat = new THREE.MeshBasicMaterial({ map: ClockOnLowLongBox })

  ClockOnTree.encoding = THREE.RGBM7Encoding;
  ClockOnTree.flipY = false;
  const ClockOnTreeMat = new THREE.MeshBasicMaterial({ map: ClockOnTree })

  LowCube.encoding = THREE.RGBM7Encoding;
  LowCube.flipY = false;
  const LowCubeMat = new THREE.MeshBasicMaterial({ map: LowCube })

  LowLongCube.encoding = THREE.RGBM7Encoding;
  LowLongCube.flipY = false;
  const LowLongCubeMat = new THREE.MeshBasicMaterial({ map: LowLongCube })

  Room.encoding = THREE.RGBM7Encoding;
  Room.flipY = false;
  const RoomMat = new THREE.MeshBasicMaterial({ map: Room })

  SmallCube.encoding = THREE.RGBM7Encoding;
  SmallCube.flipY = false;
  const SmallCubeMat = new THREE.MeshBasicMaterial({ map: SmallCube })

  Tree.encoding = THREE.RGBM7Encoding;
  Tree.flipY = false;
  const TreeMat = new THREE.MeshBasicMaterial({ map: Tree })

  const TextMat = new THREE.MeshStandardMaterial({ color: 0x240be0})
  
  const clock1time = useRef(0)
  const clock2time = useRef(0)
  const clock3time = useRef(0)

  const clock1tick = useRef()
  const clock2tick = useRef()
  const clock3tick = useRef()

  const clock1tock = useRef()
  const clock2tock = useRef()
  const clock3tock = useRef()

  // useEffect(() => {

  // })
  useFrame((state, delta) => {
    
    ticktock(clock1tick, clock1tock, clock1time, 1.1, delta)
    ticktock(clock2tick, clock2tock, clock2time, 1.2, delta)
    ticktock(clock3tick, clock3tock, clock3time, 1.0, delta)
    // console.log(delta)
  })
  return (
    <group scale={[0.5, 0.5, 0.5]} ref={group} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['1855'].geometry}
        material={TextMat}
        ref={clock1tick}
        position={[2.74, 1.35, -2.54]}
        rotation={[1.58, -0.16, 1.59]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['18_55'].geometry}
        material={TextMat}
        ref={clock1tock}
        position={[2.74, 1.35, -2.54]}
        rotation={[1.58, -0.16, 1.59]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['14_28'].geometry}
        material={TextMat}
        ref={clock2tock}
        position={[2.56, 3.11, -0.82]}
        rotation={[1.99, -0.08, 3.14]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['0703'].geometry}
        material={TextMat}
        ref={clock3tick}
        position={[-0.24, 0.77, 1.24]}
        rotation={[0.02, 1.01, -0.05]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['1428'].geometry}
        material={TextMat}
        ref={clock2tick}
        position={[2.56, 3.11, -0.82]}
        rotation={[1.99, -0.08, 3.14]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['07_03'].geometry}
        material={TextMat}
        ref={clock3tock}
        position={[-0.24, 0.77, 1.24]}
        rotation={[0.02, 1.01, -0.05]}
      />

      <mesh
        geometry={nodes.ClockOnTree.geometry}
        material={ClockOnTreeMat}
        position={[2.08, 3.63, -0.79]}
        rotation={[0, 0.08, -0.04]}
      />
      <mesh
        geometry={nodes.ClockOnLowLongBox.geometry}
        material={ClockOnLowLongBoxMat}
        position={[-0.24, 0.96, 0.73]}
        rotation={[-3.11, 0.58, 2.15]}
      />
      <mesh
        geometry={nodes.ClockOnBoxForTree.geometry}
        material={ClockOnBoxForTreeMat}
        position={[2.79, 1.64, -2.13]}
        scale={[0.39, 0.52, 0.58]}
      />
      <mesh
        geometry={nodes.SmallCube.geometry}
        material={SmallCubeMat}
        position={[-3.43, 1.09, 12.68]}
        rotation={[0, 0.02, 0]}
      />
      <mesh
        geometry={nodes.BigCube.geometry}
        material={BigCubeMat}
        position={[-5.99, 1.41, 11.41]}
        rotation={[0, -0.21, 0]}
      />
      <mesh
        geometry={nodes.Tree.geometry}
        material={TreeMat}
        position={[3.95, 1.8, -0.78]}
        rotation={[-Math.PI, 1.2, -Math.PI]}
      />
      <mesh
        geometry={nodes.LowLongCube.geometry}
        material={LowLongCubeMat}
        position={[-0.06, 0.37, 0.75]}
        rotation={[0, 0.95, 0]}
      />
      <mesh
        geometry={nodes.LowCube.geometry}
        material={LowCubeMat}
        position={[6.51, 0.31, 13.08]}
      />
      <mesh
        geometry={nodes.BoxForTree.geometry}
        material={BoxForTreeMat}
        position={[4.16, 0.44, -3.31]}
      />
      <mesh
        geometry={nodes.Room.geometry}
        material={RoomMat}
        position={[0.52, 8.78, 0]}
      />
    </group>
  )
}